import { SaleDetailModel } from 'api-hooks/sale/model';
import * as React from 'react';

import ActivityRescheduleForm from './form';

interface Props {
  activitySale: SaleDetailModel;
}

export default function xActivityReschedule(props: Props) {
  const { activitySale } = props;
  return <ActivityRescheduleForm {...props} activitySale={activitySale} />;
}
